/**
 * BoardVideoNode — 掲示板本文にアップロード動画を埋め込む TipTap カスタム Node。
 * 仕様書: docs/02_work/done/plan_board_feature.md §7-3・§7-4
 *
 * HTML 契約（サニタイザ allowlist と一致させること）:
 *   <video src="{firebase https download URL}" controls></video>
 *
 * NodeView は使わず、default レンダリングの <video controls src> をそのまま利用する。
 */
// @tiptap/core は直接依存に無いため、re-export している @tiptap/react から取り込む。
import { mergeAttributes, Node } from '@tiptap/react';

declare module '@tiptap/react' {
  interface Commands<ReturnType> {
    boardVideo: {
      /** アップロード済み動画 URL を本文に挿入する。 */
      setBoardVideo: (options: { src: string }) => ReturnType;
    };
  }
}

export const BoardVideoNode = Node.create({
  name: 'boardVideo',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      src: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [{ tag: 'video[src]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'video',
      mergeAttributes(HTMLAttributes, { controls: 'true' }),
    ];
  },

  addCommands() {
    return {
      setBoardVideo:
        (options) =>
        ({ commands }) =>
          commands.insertContent({
            type: this.name,
            attrs: { src: options.src },
          }),
    };
  },
});
